// extracted by mini-css-extract-plugin
export default {"deviceBoard":"DeviceAnalysis_deviceBoard__NBBIh","deviceItem":"DeviceAnalysis_deviceItem__Q3L+a","name":"DeviceAnalysis_name__SORMS"};